class MobileFriendlyTables {
  constructor() {
    this.tables = document.querySelectorAll(".typography table")
    this.fixedColumnTables = document.querySelectorAll(".typography table.table-fixed-first-column")

    /*
     * when the first column of a table is positioned absolute the widths of each cell is no longer the same
     * so we need to calculate which one is the widest (this.findWidestCell) and set the all to the same width
     */
    for (let i = 0; i < this.fixedColumnTables.length; i++) {
      let table = this.fixedColumnTables[i]
      let firstColumnCells = table.querySelectorAll("tr td:first-child")
      let secondColumnCells = table.querySelectorAll("tr td:nth-child(2)")
      let widestCellWidth = this.findWidestCell(firstColumnCells)
      let paddingLeft = parseInt(
        window
          .getComputedStyle(secondColumnCells[0], null)
          .getPropertyValue("padding-left")
          .replace("px", "")
      )

      /*
       * set the width of all cells in the first column to the same width and
       * increase the left padding of all cells in the second column by the width of first column
       */
      for (let i = 0; i < firstColumnCells.length; i++) {
        let firstColumnCell = firstColumnCells[i]
        let secondColumnCell = secondColumnCells[i]
        firstColumnCell.width = widestCellWidth + "px"
        secondColumnCell.style.paddingLeft = widestCellWidth + paddingLeft + "px"
      }
    }

    for (let i = 0; i < this.tables.length; i++) {
      let table = this.tables[i]
      let newHTML = "<div class='table-holder'><div class='table-holder__inner'>" + table.outerHTML + "</div></div>"
      table.outerHTML = newHTML
    }

    this.tableHolders = document.querySelectorAll(".table-holder__inner")
    this.isScrollable()
    window.addEventListener("resize", this.isScrollable.bind(this))
  }

  findWidestCell(nodes) {
    let width = 0
    for (let i = 0; i < nodes.length; i++) {
      let node = nodes[i]
      if (node.offsetWidth > width) {
        width = node.offsetWidth
      }
    }

    return width
  }

  /*
   * determines if the width of a table is greater than the width of the table holder
   */
  isScrollable() {
    for (let i = 0; i < this.tableHolders.length; i++) {
      let tableHolder = this.tableHolders[i]
      let scrollWidth = tableHolder.scrollWidth
      let divWidth = tableHolder.offsetWidth

      if (scrollWidth > divWidth) {
        tableHolder.classList.add("show-arrow-right")
        tableHolder.addEventListener("scroll", this.detectTableScrollPos.bind(this))
      } else {
        tableHolder.classList.remove("show-arrow-right")
        tableHolder.classList.remove("show-arrow-left")
        tableHolder.removeEventListener("scroll", this.detectTableScrollPos.bind(this))
      }
    }
  }

  /*
   * When a table is scrollable this function determines if the the left/right arrows should be shown
   * (to inform the user the table is scrollable)
   */
  detectTableScrollPos(ev) {
    const tableHolder = ev.target
    const scrollLeft = tableHolder.scrollLeft
    const scrollWidth = tableHolder.scrollWidth
    const divWidth = tableHolder.offsetWidth
    if (scrollLeft == 0) {
      tableHolder.classList.add("show-arrow-right")
    } else if (scrollWidth == scrollLeft + divWidth) {
      tableHolder.classList.add("show-arrow-left")
    } else {
      tableHolder.classList.remove("show-arrow-right")
      tableHolder.classList.remove("show-arrow-left")
    }
  }
}

export default MobileFriendlyTables
